import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { StyledAccordionRowItem, StyledAccordionContentWrapper, StyledAccordionToggle, StyledAccordionRowTitle, StyledAccordionText } from './ProductAccordionStyles';

var ProductAccordionItem = function ProductAccordionItem(_ref) {
  var cat = _ref.cat,
      content = _ref.content,
      defaultOpen = _ref.defaultOpen;

  var _useState = useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleAccordionClick = function handleAccordionClick() {
    setOpen(!open);
  };

  return React.createElement(
    StyledAccordionRowItem,
    { onClick: handleAccordionClick },
    React.createElement(
      StyledAccordionContentWrapper,
      null,
      React.createElement(
        StyledAccordionRowTitle,
        null,
        cat.title
      ),
      React.createElement(
        StyledAccordionText,
        { expand: open },
        content
      )
    ),
    React.createElement(
      StyledAccordionToggle,
      { expand: open },
      React.createElement('div', {
        key: cat.title + ' - Horizontal Toggle',
        className: 'accordion-toggle accordion-toggle--horizontal'
      }),
      React.createElement('div', {
        key: cat.title + ' - Vertical Toggle',
        className: 'accordion-toggle accordion-toggle--vertical'
      })
    )
  );
};

ProductAccordionItem.propTypes = {
  cat: PropTypes.object,
  content: PropTypes.array,
  defaultOpen: PropTypes.boolean
};

export default ProductAccordionItem;